import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Spinner } from '@w7/ui'
import { claims, consumeNext, handleOidcCallback, hasConsoleAccess } from '@/auth/oidc'
import './auth.css'

export function CallbackPage() {
  const navigate = useNavigate()
  const [message] = useState('Signing you in…')

  useEffect(() => {
    let cancelled = false
    void (async () => {
      const result = await handleOidcCallback()
      if (cancelled) return
      history.replaceState({}, '', '/callback')

      if (!result.ok) {
        const reason = result.reason === 'missing-code' ? 'denied' : 'error'
        navigate(`/login?reason=${reason}`, { replace: true })
        return
      }

      const who = claims()
      if (!hasConsoleAccess(who)) {
        navigate('/no-access', { replace: true })
        return
      }

      navigate(consumeNext('/'), { replace: true })
    })().catch(() => {
      if (!cancelled) navigate('/login?reason=error', { replace: true })
    })
    return () => {
      cancelled = true
    }
  }, [navigate])

  return (
    <div className="w7-auth w7-auth-center" data-testid="auth-callback">
      <Spinner size={22} />
      <p className="w7-dim" style={{ marginTop: 16 }}>
        {message}
      </p>
    </div>
  )
}
